import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

// Share links are not "cortex, for a cortex user".
//
// /p/<slug>/b/<branch>/share/apps/<view> hands ONE app to someone whose whole
// relationship with cortex is that app — typically an `app_user`: an account
// with no organization and no project access. Bouncing them to /login shows
// the wrong product's front door for something they were handed directly, so
// the share page renders its own sign-in card instead.
//
// Stepping aside grants NOTHING: the page immediately probes the app, and with
// no session renders that card. The server is the enforcement point; this only
// decides which door is shown.
const isShareRoute = (pathname) => /^\/p\/[^/]+\/b\/[^/]+\/share\/apps\//.test(pathname);

export default function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated && isShareRoute(location.pathname)) {
    return <Outlet />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
